import React from "react";
import { Button } from "flowbite-react";

import Modal from "./AnimatedModal";
import { formatDocument } from "../../utils/utils";

// Mini modal do contato repetido: o cadastro foi barrado porque o CPF/CNPJ (ou a
// raiz do CNPJ, matriz/filial) já está na base. Aponta o contato e os cards
// vinculados em vez de só dizer "já existe".
const rowClass =
  "flex w-full flex-col items-start gap-0.5 rounded-xl border border-gray-200 bg-white px-3 py-2 text-left text-sm text-gray-700 transition hover:border-[#E35412] hover:bg-orange-50";

const DuplicateContactModal = ({
  conflict,
  message,
  onOpenContact,
  onOpenCard,
  onClose,
}) => {
  const lead = conflict?.lead || {};
  const cards = Array.isArray(conflict?.cards) ? conflict.cards : [];
  const hidden = Number(conflict?.hiddenCardsCount) || 0;
  const isRoot = conflict?.kind === "cnpj_root";
  const contactName = lead.name || lead.companyName || "Contato sem nome";

  return (
    <Modal dismissible show onClose={onClose} size="md" style={{ zIndex: "10050" }}>
      <Modal.Header className="py-2">
        <div className="mt-1 text-base">
          {isRoot ? "Empresa já cadastrada" : "Contato já cadastrado"}
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3 text-sm text-gray-600">
          {isRoot
            ? "Já existe um contato desta empresa na base (mesmo CNPJ raiz, ou seja, a matriz ou outra filial). Nada foi criado: abra o contato ou um dos cards abaixo."
            : message || "Este contato já existe na base. Nada foi criado."}
        </p>

        <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Contato
        </div>
        <button type="button" onClick={onOpenContact} className={rowClass}>
          <span className="w-full truncate font-medium">{contactName}</span>
          {lead.companyName && lead.companyName !== contactName ? (
            <span className="w-full truncate text-xs text-gray-500">
              {lead.companyName}
            </span>
          ) : null}
          {lead.document ? (
            <span className="w-full truncate text-xs text-gray-500">
              {formatDocument(lead.document)}
            </span>
          ) : null}
        </button>

        <div className="mb-1 mt-4 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Cards vinculados
        </div>
        {cards.length ? (
          <div className="max-h-56 space-y-2 overflow-y-auto pr-1">
            {cards.map((card) => (
              <button
                key={card.id}
                type="button"
                onClick={() => onOpenCard(card)}
                className={rowClass}
              >
                <span className="w-full truncate font-medium">
                  {card.title || "Card sem título"}
                </span>
                {card.funnelName || card.stageName ? (
                  <span className="w-full truncate text-xs text-gray-500">
                    {[card.funnelName, card.stageName].filter(Boolean).join(" › ")}
                  </span>
                ) : null}
                {card.responsibleName ? (
                  <span className="w-full truncate text-xs text-gray-500">
                    Responsável: {card.responsibleName}
                  </span>
                ) : null}
              </button>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            {hidden
              ? "Os cards deste contato estão em funis que você não acessa."
              : "Este contato ainda não tem cards."}
          </p>
        )}
        {cards.length && hidden ? (
          <p className="mt-2 text-xs text-gray-500">
            {hidden === 1
              ? "Há mais 1 card em um funil que você não acessa."
              : `Há mais ${hidden} cards em funis que você não acessa.`}
          </p>
        ) : null}
      </Modal.Body>
      <Modal.Footer className="flex justify-center gap-2 pt-2 pb-3">
        <Button color="light" onClick={onClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DuplicateContactModal;
